










































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {Env} from '@/helpers/Env'

@Component
export default class ListReprocessamentoWebhookView extends Mixins(
  MixinQueryRouter
) {
  async created() {
    await this.query()
  }

  async uploadByCsv() {
    const file = await Helper.promptForSingleFile('.csv')

    if (file) {
      const data = await Helper.csvToNormalizedData(
        file,
        Env.CSV_BLUEPRINT.reprocessWebhook
      )

      const ids = data.map(item => Number(item.id))

      if (ids.some(id => isNaN(id))) {
        Helper.abort('system.error.wrongFormat')
      }

      const response = await Carga.batchReprocessarWebhook(ids)
      const {linhasReprocessadas, linhasNaoExistentes, linhasNaFila} = response

      if (linhasNaFila) {
        linhasNaFila.forEach(linha => {
          this.$snotify.warning(
            this.$t('system.info.cargaToBeReprocessed', {
              linha: linha + 1,
            }) as string
          )
        })
      }

      await Helper.sleep(500)

      if (linhasNaoExistentes) {
        linhasNaoExistentes.forEach(linha => {
          this.$snotify.error(
            this.$t('system.error.cargaNotReprocessed', {
              linha: linha + 1,
            }) as string
          )
        })
      }

      await Helper.sleep(500)

      if (linhasReprocessadas) {
        const reprocessedLength = linhasReprocessadas.length
        this.$snotify.success(
          this.$t('system.info.cargaReprocessed', {reprocessedLength}) as string
        )
      }
    }
  }
}
